import { SxProps, Theme } from '@mui/material'

export const overlaySx: SxProps<Theme> = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  background:
    'linear-gradient(90deg, rgba(0, 0, 0, 0.80) 37.95%, rgba(0, 0, 0, 0.00) 100%)',
  maxWidth: {
    lg: '63%',
    xl: '72.24%',
  },
}

export const containerSx: SxProps<Theme> = {
  position: 'relative',
  height: {
    lg: '54rem',
  },
  background: {
    xs: 'url(/images/tech-vendors-features-hero-bg.webp) no-repeat center right 35%',
    md: 'url(/images/tech-vendors-features-hero-bg.webp) no-repeat center right 40%',
    lg: 'url(/images/tech-vendors-features-hero-bg.webp) no-repeat bottom 20% right',
    xl: 'url(/images/tech-vendors-features-hero-bg.webp) no-repeat bottom 20% right',
  },
  backgroundSize: 'cover !important',
  display: 'flex',
  padding: {
    xs: '6rem 2.4rem',
    md: '6.2rem 5.6rem',
    lg: 0,
  },
}

export const contentSx: SxProps<Theme> = {
  position: 'relative',
  zIndex: 2,
  width: {
    xs: '100%',
    lg: '117.6rem',
    xl: '151.6rem',
  },
  margin: 'auto',
}

export const heroLeftSideContentSx: SxProps<Theme> = {
  alignItems: {
    xs: 'center',
    md: 'start',
  },
  maxWidth: {
    lg: '54.3rem',
    xl: '95.3rem',
  },
  marginRight: 'auto',
  textAlign: {
    xs: 'center',
    md: 'initial',
  },
}

export const heroOverTitleSx: SxProps<Theme> = {
  alignSelf: {
    xs: 'center',
    md: 'start',
  },
  paddingBottom: '0.8rem',
  color: (theme) => theme.palette.primary.contrastText,
  borderBottom: (theme) => `0.1rem solid ${theme.palette.primary.contrastText}`,
}

export const heroTitleSx: SxProps<Theme> = {
  marginTop: '1.6rem',
  color: (theme) => theme.palette.primary.contrastText,
}

export const heroSubtitleSx: SxProps<Theme> = {
  marginTop: {
    xs: '1.6rem',
    lg: '2.4rem',
  },
  lineHeight: '2.6rem',
  '& > span:not(:first-of-type)': {
    display: 'block',
    marginTop: {
      xs: '0.4rem',
      md: '1rem',
    },
  },
  color: (theme) => theme.palette.primary.contrastText,
}

export const subscribeButtonSx: SxProps<Theme> = {
  marginTop: {
    xs: '1.6rem',
    lg: '2.4rem',
  },
  fontWeight: '700',
  minHeight: '5.2rem',
  paddingLeft: '2rem',
  alignSelf: {
    xs: 'stretch',
    md: 'initial',
  },
}
